import type { CustomThemeConfig } from '@pba/react-theme';
import type { ComponentProps, ReactNode } from 'react';
import { Col } from '../../col';
import { useResolveSpacingValue } from '../../hooks';
import { Row } from '../../row';
import { Text } from '../../typography';

export type HorizontalScrollProperties = {
  className?: string;
  gap?: keyof CustomThemeConfig['spacing'] | number;
  items: ScrollItem[];
  span?: HorizontalScrollSpan;
  title?: ReactNode;
};

type HorizontalScrollSpan = 'auto' | ({} & string) | Exclude<ComponentProps<typeof Col>['span'], string>;

type ScrollItem = {
  key: ComponentProps<typeof Col>['key'];
} & Omit<ComponentProps<typeof Col>, 'key'>;

const HorizontalScroll = ({ className, gap, items, span = 7, title }: HorizontalScrollProperties) => {
  const resolveSpacingValue = useResolveSpacingValue();

  return (
    <Row gutter={[0, 'ms']}>
      {title ? (
        <Col span={24}>
          {typeof title === 'string' ? (
            <Text size="small" type="title" uppercase weight="medium">
              {title}
            </Text>
          ) : (
            title
          )}
        </Col>
      ) : null}
      <Col span={24}>
        <Row
          className={className}
          style={gap === undefined ? undefined : { columnGap: resolveSpacingValue({ value: gap }) }}
          wrap={false}
        >
          {items.map(({ key, ...item }) => (
            <Col
              alignItems="flexStart"
              flex={span === 'auto' ? 'none' : undefined}
              justifyContent="center"
              key={key}
              span={span === 'auto' ? undefined : span}
              {...item}
            />
          ))}
        </Row>
      </Col>
    </Row>
  );
};

export default HorizontalScroll;
